import { useState, useEffect, useCallback } from 'react';
import { employeeService } from '../services/employeeService';

export function useEmployees() {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const fetchEmployees = useCallback(async () => {
    try {
      setLoading(true);
      const params = {
        search: searchQuery,
      };
      
      const response = await employeeService.getEmployees(params);
      
      // Response se direct data array set kar rahe hain
      setEmployees(response.data || response || []);
      setError(null);
    } catch (err) {
      setError('Failed to load employees data from server.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [searchQuery]);

  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  return {
    employees,
    loading,
    error,
    searchQuery,
    setSearchQuery,
    refetch: fetchEmployees,
  };
}